


























































































































































































































































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { mapGetters } from 'vuex'

import DepressionMixin from '@/views/treatment/depression/DepressionMixin'
import WelcomeToPatientLetter from './WelcomeToPatientLetter.vue'

export default mixins(DepressionMixin).extend({
  components: { WelcomeToPatientLetter },
  computed: {
    ...mapGetters('workflow', ['isDone']),
  },
})
